import React from 'react'
import intl from 'react-intl-universal'
import { Ellipsis } from 'antd-mobile';
import { DownOutline, UpOutline } from 'antd-mobile-icons';
import { formatJSON, decodeHtmlEntities } from '../../utils'
const stripHtmlTags = (str) => {
    if (!str) return '';
    return str.replace(/<[^>]*>/g, '');
}

const RenderText = ({ text, ellipsis = false, cls, needExpand = false }) => {
    if (!text) return null
    // console.log(text, '///===text==///',text.length)
    if (ellipsis) {
        return <Ellipsis
            onContentClick={(e)=>{
                console.log(e,'///===e==///')
            }}
            content={decodeHtmlEntities(text.trimEnd())}
            expandText={needExpand ? <span>&nbsp;{intl.get('showMore').d('展开')}<DownOutline /></span> : null}
            collapseText={needExpand ? <span>&nbsp;{intl.get('collapse').d('收起')}<UpOutline /></span> : null} />
    }
    return <div className={cls}>{decodeHtmlEntities(text)}</div>
}

const ProductDesc = ({ list, cls, ellipsis = false, needExpand = false }) => {
    if (!list) return null
    if (list.length === 0) return null
    const obj = formatJSON(list)
    if (obj) {
        if (typeof obj === 'object') {
            list = Object.values(obj)
        }

        const txtArr = list.filter(item => item.type === 'text' && item.value).map(item => item.value)
        if (txtArr.length === 0) return null
        return (
            <div className={cls}>
                <RenderText text={txtArr.join()} ellipsis={ellipsis} cls={cls} needExpand={needExpand} />
            </div>
        )
    } else {
        const txt = stripHtmlTags(list)
        return <div className={cls} style={cls ? null : { whiteSpace: 'pre-wrap', textAlign: 'left' }}>
            <RenderText text={txt} ellipsis={ellipsis} cls={cls} />
        </div>
    }
}

export default ProductDesc
